// Mobile swipe carousel for product card images (Dawn theme, max-width: 749px)
// Vereist bijbehorende CSS in assets/base.css (.card__media-swipe / -track / -link / -image)
// en HTML-structuur uit snippets/card-product.liquid (foto's gewrapt in .card__media-swipe-link)
(function () {
  // Werkt nu document-breed, zodat elke sectie die card-product.liquid rendert
  // (collectiepagina's, homepage productblokken, etc.) automatisch swipebaar is.
  if (document.documentElement.dataset.cardSwipeInit) return;
  document.documentElement.dataset.cardSwipeInit = 'true';
  var container = document;

  var current = null;
  var track = null;
  var startX = 0;
  var startY = 0;
  var containerWidth = 0;
  var currentIndex = 0;
  var itemCount = 1;
  var dragging = false;
  var lockedHorizontal = false;
  var dragOffset = 0;
  var rawDeltaX = 0;
  var pendingOffset = null;
  var rafId = null;

  // Tijdens het slepen fadet de foto waar je naartoe sleept in (0 -> 1),
  // op basis van hoever je al bent gesleept t.o.v. de containerbreedte.
  function updateIncomingFade() {
    if (!track) return;
    var progress = Math.min(Math.abs(rawDeltaX) / containerWidth, 1);
    var direction = rawDeltaX > 0 ? 1 : -1;
    var incomingIndex = currentIndex + direction;
    var imgs = track.querySelectorAll('.card__media-swipe-image');

    for (var i = 0; i < imgs.length; i++) {
      if (i === incomingIndex && incomingIndex >= 0 && incomingIndex < itemCount) {
        imgs[i].style.opacity = progress;
      } else if (i !== currentIndex) {
        imgs[i].style.opacity = 1;
      }
    }
  }

  function applyOffset() {
    if (pendingOffset !== null && track) {
      track.style.transform = 'translateX(' + pendingOffset + 'px)';
      updateIncomingFade();
      pendingOffset = null;
    }
    rafId = null;
  }

  container.addEventListener(
    'touchstart',
    function (e) {
      var swipeEl = e.target.closest('.card__media-swipe');
      if (!swipeEl) return;
      current = swipeEl;
      track = swipeEl.querySelector('.card__media-swipe-track');
      if (!track) return;
      containerWidth = swipeEl.getBoundingClientRect().width;
      currentIndex = parseInt(swipeEl.dataset.swipeIndex || '0', 10);
      itemCount = track.children.length;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
      lockedHorizontal = false;
      rawDeltaX = 0;
      track.style.transition = 'none';
      var imgs = track.querySelectorAll('.card__media-swipe-image');
      for (var i = 0; i < imgs.length; i++) imgs[i].style.transition = 'none';
    },
    { passive: true }
  );

  container.addEventListener(
    'touchmove',
    function (e) {
      if (!dragging || !track) return;
      var deltaX = startX - e.touches[0].clientX;
      var deltaY = startY - e.touches[0].clientY;

      // Kleine dode zone (5px) om te bepalen of dit een horizontale swipe is
      // of een verticale scroll van de pagina; bij verticaal laten we los.
      if (!lockedHorizontal) {
        if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) return;
        lockedHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        if (!lockedHorizontal) {
          dragging = false;
          return;
        }
      }

      e.preventDefault();
      rawDeltaX = deltaX;
      dragOffset = -(currentIndex * containerWidth) - deltaX;

      // Rubberband-weerstand aan de randen (eerste/laatste foto)
      var minOffset = -(itemCount - 1) * containerWidth;
      if (dragOffset > 0) {
        dragOffset = dragOffset * 0.3;
      } else if (dragOffset < minOffset) {
        dragOffset = minOffset + (dragOffset - minOffset) * 0.3;
      }

      pendingOffset = dragOffset;
      if (rafId === null) {
        rafId = requestAnimationFrame(applyOffset);
      }
    },
    { passive: false }
  );

  container.addEventListener(
    'touchend',
    function () {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (current && track && lockedHorizontal) {
        // Vanaf 18% van de containerbreedte gesleept: schakel door naar volgende/vorige foto
        var threshold = containerWidth * 0.18;
        var nearestIndex = currentIndex;

        if (rawDeltaX > threshold) {
          nearestIndex = currentIndex + 1;
        } else if (rawDeltaX < -threshold) {
          nearestIndex = currentIndex - 1;
        }

        nearestIndex = Math.max(0, Math.min(itemCount - 1, nearestIndex));
        track.style.transition = 'transform 0.3s cubic-bezier(0.22, 0.61, 0.36, 1)';
        track.style.transform = 'translateX(' + -(nearestIndex * containerWidth) + 'px)';
        current.dataset.swipeIndex = nearestIndex;

        var imgs = track.querySelectorAll('.card__media-swipe-image');
        for (var i = 0; i < imgs.length; i++) {
          imgs[i].style.transition = 'opacity 0.3s ease';
          imgs[i].style.opacity = 1;
        }
      }
      dragging = false;
      lockedHorizontal = false;
      current = null;
      track = null;
    },
    { passive: true }
  );
})();
